(function () {
  var header = document.querySelector('[data-skin-header]');
  if (!header) return;

  var onScroll = function () {
    if (window.scrollY > 8) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.querySelectorAll('.skin-footer__column--collapsible .skin-footer__heading').forEach(function (heading) {
    heading.addEventListener('click', function () {
      if (window.innerWidth >= 576) return;
      heading.closest('.skin-footer__column--collapsible').classList.toggle('is-open');
    });
  });
})();
